// extracted by mini-css-extract-plugin
export default {"spinner":"Spinner-module_spinner_NjaYyp"};